/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum commandEnum {
    HEALTH = 'health',
    ANSWER = 'answer',
    MEETING_ID = 'meetingId',
    NO_MEETING_ID = 'noMeetingId',
    MEETING_PIN = 'meetingPin',
    END_RECORDING = 'endRecording',
    SIP_INCOMING = 'sipIncoming',
}